import pdfIcon from "../../assets/svg/file-types/pdf.svg";
import docIcon from "../../assets/svg/file-types/doc.svg";
import docxIcon from "../../assets/svg/file-types/docx.svg";
import pptIcon from "../../assets/svg/file-types/ppt.svg";
import pptxIcon from "../../assets/svg/file-types/pptx.svg";
import xlsIcon from "../../assets/svg/file-types/xls.svg";
import xlsxIcon from "../../assets/svg/file-types/xlsx.svg";
import txtIcon from "../../assets/svg/file-types/txt.svg";
import pngIcon from "../../assets/svg/file-types/png.svg";
import jpgIcon from "../../assets/svg/file-types/jpg.svg";
import jpegIcon from "../../assets/svg/file-types/jpeg.svg";
import gifIcon from "../../assets/svg/file-types/gif.svg";
import svgIcon from "../../assets/svg/file-types/svg.svg";
import tiffIcon from "../../assets/svg/file-types/tiff.svg";
import psdIcon from "../../assets/svg/file-types/psd.svg";
import aiIcon from "../../assets/svg/file-types/ai.svg";
import epsIcon from "../../assets/svg/file-types/eps.svg";
import inddIcon from "../../assets/svg/file-types/indd.svg";
import mp3Icon from "../../assets/svg/file-types/mp3.svg";
import wavIcon from "../../assets/svg/file-types/wav.svg";
import mp4Icon from "../../assets/svg/file-types/mp4.svg";
import mpegIcon from "../../assets/svg/file-types/mpeg.svg";
import aviIcon from "../../assets/svg/file-types/avi.svg";
import mkvIcon from "../../assets/svg/file-types/mkv.svg";
import htmlIcon from "../../assets/svg/file-types/html.svg";
import cssIcon from "../../assets/svg/file-types/css.svg";
import jsIcon from "../../assets/svg/file-types/js.svg";
import jsonIcon from "../../assets/svg/file-types/json.svg";
import sqlIcon from "../../assets/svg/file-types/sql.svg";
import xmlIcon from "../../assets/svg/file-types/xml.svg";
import zipIcon from "../../assets/svg/file-types/zip.svg";
import rarIcon from "../../assets/svg/file-types/rar.svg";
import dmgIcon from "../../assets/svg/file-types/dmg.svg";
import exeIcon from "../../assets/svg/file-types/exe.svg";
import javaIcon from "../../assets/svg/file-types/java.svg";
import csvIcon from "../../assets/svg/file-types/csv.svg";
import aepIcon from "../../assets/svg/file-types/aep.svg";
import figIcon from "../../assets/svg/file-types/fig.svg";
import webpIcon from "../../assets/svg/file-types/webp.svg";
import rssIcon from "../../assets/svg/file-types/rss.svg";
import spreadsheetIcon from "../../assets/svg/file-types/spreadsheet.svg";
import videoIcon from "../../assets/svg/file-types/video.svg";
import imageIcon from "../../assets/svg/file-types/image.svg";
import audioIcon from "../../assets/svg/file-types/audio.svg";
import codeIcon from "../../assets/svg/file-types/code.svg";
import documentIcon from "../../assets/svg/file-types/document.svg";
import folderIcon from "../../assets/svg/file-types/folder.svg";
import emptyIcon from "../../assets/svg/file-types/empty.svg";

const defaultFileIcon = documentIcon;

export const getFileTypeIcon = (fileName: string): string => {
  if (!fileName || typeof fileName !== "string") {
    return defaultFileIcon;
  }

  const extension = fileName.split(".").pop()?.toLowerCase();

  if (!extension) {
    return defaultFileIcon;
  }

  const fileTypeMap: Record<string, string> = {
    pdf: pdfIcon,
    doc: docIcon,
    docx: docxIcon,
    ppt: pptIcon,
    pptx: pptxIcon,
    xls: xlsIcon,
    xlsx: xlsxIcon,
    txt: txtIcon,
    csv: csvIcon,
    png: pngIcon,
    jpg: jpgIcon,
    jpeg: jpegIcon,
    gif: gifIcon,
    svg: svgIcon,
    tiff: tiffIcon,
    tif: tiffIcon,
    psd: psdIcon,
    ai: aiIcon,
    eps: epsIcon,
    indd: inddIcon,
    webp: webpIcon,
    fig: figIcon,
    mp3: mp3Icon,
    wav: wavIcon,
    mp4: mp4Icon,
    mpeg: mpegIcon,
    avi: aviIcon,
    mkv: mkvIcon,
    aep: aepIcon,
    html: htmlIcon,
    htm: htmlIcon,
    css: cssIcon,
    js: jsIcon,
    javascript: jsIcon,
    ts: jsIcon,
    typescript: jsIcon,
    jsx: jsIcon,
    tsx: jsIcon,
    json: jsonIcon,
    sql: sqlIcon,
    xml: xmlIcon,
    rss: rssIcon,
    zip: zipIcon,
    rar: rarIcon,
    dmg: dmgIcon,
    exe: exeIcon,
    java: javaIcon,
    video: videoIcon,
    image: imageIcon,
    audio: audioIcon,
    code: codeIcon,
    document: documentIcon,
    folder: folderIcon,
    empty: emptyIcon,
    spreadsheet: spreadsheetIcon,
  };

  return fileTypeMap[extension] || defaultFileIcon;
};
